import React from 'react';
import SEOHead from '../components/SEOHead';
import BreadcrumbSchema from '../components/BreadcrumbSchema';

const resources = [
  {
    title: 'Quick Start',
    description: 'Upload your first video, review AI highlights, and publish in 15 minutes or less.',
    links: [
      { label: 'Upload walkthrough', href: '/tutorials/how-to-create-viral-clips' },
      { label: 'Export templates guide', href: '/tutorials/ai-highlight-detection' },
    ],
  },
  {
    title: 'Account & Billing',
    description: 'Manage seats, invoices, and plan upgrades from the dashboard.',
    links: [
      { label: 'Pricing overview', href: '/pricing' },
      { label: 'Lifetime vs Pro FAQ', href: '/faq' },
    ],
  },
  {
    title: 'Need help fast?',
    description: 'Message support and share a debug log directly from ClipThis.',
    links: [
      { label: 'support@clipthis.io', href: 'mailto:support@clipthis.io' },
      { label: 'Creator Discord', href: 'https://discord.gg/clipthis' },
    ],
  },
];

const Help: React.FC = () => {
  return (
    <>
      <SEOHead
        title="Help Center - ClipThis"
        description="Find quick start guides, billing answers, and support channels for ClipThis."
        url="/help"
      />
      <BreadcrumbSchema items={[{ name: 'Help', path: '/help' }]} />
      <div className="relative overflow-hidden bg-white">
        <div className="absolute inset-0 dot-pattern-animated opacity-30 pointer-events-none" />
        <section className="relative z-10 max-w-5xl mx-auto px-6 py-16 animate-fade-up">
          <p className="text-red-600 uppercase tracking-[0.3em] text-xs mb-3">Help Center</p>
          <h1 className="text-4xl font-display font-bold text-gray-900 mb-6">Support without the wait</h1>
          <p className="text-lg text-gray-600 mb-10">
            Use the guides below or contact us directly. The ClipThis team answers every ticket personally—no bots, no scripted replies.
          </p>
          <div className="grid md:grid-cols-3 gap-6">
            {resources.map((resource) => (
              <div key={resource.title} className="p-6 rounded-2xl border border-gray-200 bg-gray-50">
                <h2 className="text-2xl font-semibold text-gray-900 mb-3">{resource.title}</h2>
                <p className="text-gray-600 mb-4">{resource.description}</p>
                <ul className="space-y-2">
                  {resource.links.map((link) => (
                    <li key={link.label}>
                      <a href={link.href} className="text-red-600 font-medium hover:underline">
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </section>
      </div>
    </>
  );
};

export default Help;

